// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"445":"wxLogin","474":"agreementImg","671":"wxHome","973":"agreement"}[chunkId] + "." + {"445":"ca0963a1","474":"4f0e82a9","671":"7ab76b9b","973":"74733ff9"}[chunkId] + ".js";
};